import { client } from "./client";
import {
  Bookmark, BookmarkCreateRequest,
} from "../types/Bookmark";

export function apiCreateBookmark(
  organizationId: number,
  workspaceId: number,
  bookmarkCreateRequest: BookmarkCreateRequest
) {
  return client.post(
    `/organizations/${organizationId}/workspaces/${workspaceId}/bookmarks`,
    bookmarkCreateRequest
  );
}